import { NavigationHeaderContext } from "./NavigationHeaderContext";
import { SearchOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import React, { useContext, useRef } from 'react';
var HeaderInput = function HeaderInput() {
  var headerInputRef = useRef(null);
  var NavigationHeaderContextProps = useContext(NavigationHeaderContext);
  var searchComponent = NavigationHeaderContextProps.searchComponent,
    onSearch = NavigationHeaderContextProps.onSearch,
    uid = NavigationHeaderContextProps.uid;
  var defaultSearchComponent = /*#__PURE__*/React.createElement(Input, {
    ref: headerInputRef,
    allowClear: true,
    placeholder: uid ? '请输入搜索内容' : '登录后方可搜索',
    className: "dr-nav-input",
    suffix: /*#__PURE__*/React.createElement(SearchOutlined, {
      style: {
        color: '#8596AC'
      },
      onClick: function onClick() {
        var value = headerInputRef.current.input.value;
        if (value) {
          if (onSearch) {
            onSearch === null || onSearch === void 0 || onSearch(value);
          } else {
            window.open("https://search.fanruan.com/?q=".concat(value));
          }
        }
      },
      rev: undefined
    }),
    disabled: !uid,
    onPressEnter: function onPressEnter(e) {
      var _ref = e.target,
        value = _ref.value;
      if (value) {
        if (onSearch) {
          onSearch === null || onSearch === void 0 || onSearch(value);
        } else {
          window.open("https://search.fanruan.com/?q=".concat(value));
        }
      }
    }
  });
  var renderInputCompoent = function renderInputCompoent() {
    if (searchComponent === undefined) {
      return defaultSearchComponent;
    } else if (searchComponent === false) {
      return null;
    }
    return searchComponent;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderInputCompoent());
};
export default HeaderInput;